/**
 * Accepted shape for a workspace subdomain: a leading letter, then
 * hyphen-separated alphanumeric labels.
 *
 * Kept in sync with `validate_domain_name` in Core
 * (`apps/common/validators.py`) — a stricter copy here only produces a form
 * error the backend would have accepted, a looser one lets the request through
 * and surfaces a server error instead.
 */
export const SERVICE_DOMAIN_REGEXP = /^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/
